import React, { Component } from 'react';
import Banner from './banner';
import About from './about';
import Services from './services';
import Reviews from './reviews';

import andrew from '../../assets/images/reviews/andrew.jpg';
import jackie from '../../assets/images/reviews/jackie.jpg';
import lindsay from '../../assets/images/reviews/lindsay.jpg';
import meg from '../../assets/images/reviews/meg.jpg';
import flowerIcon from '../../assets/icon/flower.svg';
import handIcon from '../../assets/icon/hand.svg';
import houseIcon from '../../assets/icon/house.svg';

import Pricing from './pricing';
import Contact from './contact';

class Main extends Component {
  state = {
    reviews: [
      {
        image: { label: 'lindsay', img: lindsay },
        name: 'Lindsay M.',
        paragraph:
          'Pawtastic is awesome! They are passionate about pets and employ trustworthy, dependable staff. We love them!',
      },
      {
        image: { label: 'andrew', img: andrew },
        name: 'Andrew C.',
        paragraph:
          'I’m a repeat customer because of their amazing care for our two cats when we travel. I can relax because I know they’re there!',
      },
      {
        image: { label: 'meg', img: meg },
        name: 'Meg F.',
        paragraph:
          'I use them for mid day walks and our babies are so happy with the exercise and love during the day. We see the difference!',
      },
      {
        image: { label: 'jackie', img: jackie },
        name: 'Jackie B.',
        paragraph:
          'I just returned from two weeks away to a sociable, calm cat and no drama. Thanks for a great job, Pawtastic!',
      },
    ],

    pricing: [
      {
        type: 'Dog walk',
        description:
          'We’ll take your pup for a 30 minute walk and make sure he or she has fresh food and water.',
        price: 15,
        icon: flowerIcon,
        brief: 'per 30 mins walk',
      },
      {
        type: 'Drop-in Visit',
        description:
          'We’ll stop by to snuggle, feed, and play with your pets in the comfort of their own home.',
        price: 15,
        icon: handIcon,
        brief: 'per 30 mins visit',
      },
      {
        type: 'House sitting',
        description:
          'We’ll stay overnight with your pets to make sure they have round-the-clock love.',
        price: 15,
        icon: houseIcon,
        brief: 'per night',
      },
    ],
  };
  render() {
    return (
      <React.Fragment>
        <Banner />
        <About />
        <Services />
        <Reviews items={this.state.reviews} />
        <Pricing items={this.state.pricing} />
        <Contact />
      </React.Fragment>
    );
  }
}

export default Main;
